<template>
    <div class="animated fadeIn">
        <table-tabs></table-tabs>
    </div>
</template>

<script>
  import Tabs from './Tabs'

  export default {
    components: {
      'table-tabs': Tabs
    },
    data: () => {
      return {}
    },
    mounted () {
    },
    computed: {},
    created () {

    },
    methods: {}
  }
</script>

<style lang="stylus">
</style>


